

var CurrentUser = require("lib/account/CurrentUser");
var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var BackLogReadingPreference = require("components/users/teachers/preferences/logs/BackLogReadingPreference");
var LogReadingViewPreference = require("components/users/teachers/preferences/logs/LogReadingViewPreference");
var PromptLogReadingPreference = require("components/users/teachers/preferences/PromptLogReadingPreference");


class LogReadingPreference extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	render() {
		var promptLogReadingPreference = (<PromptLogReadingPreference />)
		var logReadingViewPreference = (<LogReadingViewPreference />)
		var backLogReadingPreference = (<BackLogReadingPreference />)
		return (
			<div>
				{ promptLogReadingPreference }
				{ logReadingViewPreference }
				{ backLogReadingPreference }
			</div>
		)
	}
}


module.exports = LogReadingPreference;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/LogReadingPreferences.js